/*
 * action types
 */

export const REPLACE_SELLERS = "REPLACE_SELLERS";
export const CLEAR_SELLERS = "CLEAR_SELLERS";
export const SET_SELLERS_TEXTFIELD = "SET_SELLERS_TEXTFIELD";
export const SET_SELLERS_PAGESIZE = "SET_SELLERS_PAGESIZE";
export const SET_SELLERS_PAGENUMBER = "SET_SELLERS_PAGENUMBER";
export const DELETE_SELLER = "DELETE_SELLER";

/*
 * action creators
 */

export const Replace = (values, totalResults, totalPage) => ({ 
    type: REPLACE_SELLERS,
    sellers: values,
    totalResults,
    totalPage
});

export const Clear = () => ({
    type: CLEAR_SELLERS
})

export const SetPageSize = (pageSize) => ({
    type: SET_SELLERS_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_SELLERS_PAGENUMBER,
    pageNumber
})

export const SetTextField = (textField) => ({
    type: SET_SELLERS_TEXTFIELD,
    textField
})